// Generated by ServiceInterfaceGenerator Aug 28, 2018 11:02:47 AM
import { sharedReactorWebsocket as ws } from '../reactor.js';

class DashboardUserSessionServiceInterface {
  constructor() {
    this.service_id = 'dashboardusersessionservice-1_2';
  }

  // DashboardUserSessionCreateAction, Response: DashboardUserSessionCreateResponse
  // authType: String
  // authToken: String
  // tenancyId: int
  // validityPeriodSeconds: long
  // ipAddress: String
  // userId: String
  // userAgent: String
  // originApp: String
  createSession(authType, authToken, tenancyId, validityPeriodSeconds, ipAddress, userId, userAgent, originApp, success_callback) {
    return ws.sendServiceRequest(this.service_id, 'DashboardUserSessionCreateAction', { authType: authType, authToken: authToken, tenancyId: tenancyId, validityPeriodSeconds: validityPeriodSeconds, ipAddress: ipAddress, userId: userId, userAgent: userAgent, originApp: originApp }, success_callback);
  }

  // DashboardUserSessionRequest, Response: DashboardUserSessionResponse
  // sessionId: String
  // tenancyId: int
  getSession(sessionId, tenancyId, success_callback) {
    return ws.sendServiceRequest(this.service_id, 'DashboardUserSessionRequest', { sessionId: sessionId, tenancyId: tenancyId }, success_callback);
  }

  // DashboardUserPendingLoginRequest, Response: DashboardUserPendingLoginResponse
  // loginId: String
  // tenancyId: int
  getDashboardUserPendingLoginRequest(loginId, tenancyId, success_callback) {
    return ws.sendServiceRequest(this.service_id, 'DashboardUserPendingLoginRequest', { loginId: loginId, tenancyId: tenancyId }, success_callback);
  }

  // DashboardUserSessionRefreshAction, Response: DashboardUserSessionRefreshResponse
  // sessionId: String
  // tenancyId: int
  refreshSession(sessionId, tenancyId, success_callback) {
    return ws.sendServiceRequest(this.service_id, 'DashboardUserSessionRefreshAction', { sessionId: sessionId, tenancyId: tenancyId }, success_callback);
  }

  // DashboardUserSessionDeleteAction, Response: DashboardUserSessionDeleteResponse
  // sessionId: String
  // tenancyId: int
  deleteSession(sessionId, tenancyId, success_callback) {
    return ws.sendServiceRequest(this.service_id, 'DashboardUserSessionDeleteAction', { sessionId: sessionId, tenancyId: tenancyId }, success_callback);
  }

  // TransferSessionRequest, Response: TransferSessionResponse
  // properties: Map<String,String>
  getTransferSessionToken(properties, success_callback) {
    return ws.sendServiceRequest(this.service_id, 'TransferSessionRequest', { properties: properties }, success_callback);
  }

  // ResolveTransferSessionTokenAction, Response: ResolveTransferSessionTokenResponse
  // transferToken: String
  resolveTransferSessionToken(transferToken, success_callback) {
    return ws.sendServiceRequest(this.service_id, 'ResolveTransferSessionTokenAction', { transferToken: transferToken }, success_callback);
  }

  // AddUpdateDashboardUserAgreementRequest, Response: AddUpdateDashboardUserAgreementResponse
  // tenancyId: Integer
  // text: String
  // confirmationRequired: Boolean
  addAgreement(tenancyId, text, confirmationRequired) {
    return ws.sendServiceRequest(this.service_id, 'AddUpdateDashboardUserAgreementRequest', { tenancyId: tenancyId, agreementText: text, confirmationRequired: confirmationRequired });
  }

  // AddUpdateDashboardUserAgreementRequest, Response: AddUpdateDashboardUserAgreementResponse
  // agreementId: Integer
  // tenancyId: Integer
  // text: String
  // confirmationRequired: Boolean
  updateAgreement(agreementId, tenancyId, text, confirmationRequired, enabled = true) {
    return ws.sendServiceRequest(this.service_id, 'AddUpdateDashboardUserAgreementRequest', { tenancyId: tenancyId, agreementText: text, confirmationRequired: confirmationRequired, agreementId: agreementId, enabled: enabled });
  }

  // GetDashboardUserTenancyAgreementsRequest, Response: GetDashboardUserTenancyAgreementsResponse
  // tenancyId: Integer
  getAgreements(tenancyId) {
    return ws.sendServiceRequest(this.service_id, 'GetDashboardUserTenancyAgreementsRequest', { tenancyId: tenancyId });
  }

  // ConfirmDashboardUserAgreementRequest, Response: ConfirmDashboardUserAgreementResponse
  // agreement: com.lumi.dashboardusersessionservice.api.DashboardUserAgreement
  // dashboardUserId: String
  confirmAgreement(agreement, dashboardUserId) {
    return ws.sendServiceRequest(this.service_id, 'ConfirmDashboardUserAgreementRequest', { agreement: agreement, dashboardUserId: dashboardUserId, confirmed: true });
  }

  // ConfirmDashboardUserAgreementRequest, Response: ConfirmDashboardUserAgreementResponse
  // agreement: com.lumi.dashboardusersessionservice.api.DashboardUserAgreement
  // dashboardUserId: String
  denyAgreement(agreement, dashboardUserId) {
    return ws.sendServiceRequest(this.service_id, 'ConfirmDashboardUserAgreementRequest', { agreement: agreement, dashboardUserId: dashboardUserId, confirmed: false });
  }

  // GetPendingDashboardUserAgreementsRequest, Response: GetPendingDashboardUserAgreementsResponse
  // dashboardUserId: String
  // tenancyId: Integer
  getPendingAgreements(dashboardUserId, tenancyId) {
    return ws.sendServiceRequest(this.service_id, 'GetPendingDashboardUserAgreementsRequest', { dashboardUserId: dashboardUserId, tenancyId: tenancyId });
  }

  // RemoveAgreementRequest, Response: RemoveAgreementResponse
  // agreement: com.lumi.dashboardusersessionservice.api.DashboardUserAgreement
  removeAgreement(agreement) {
    return ws.sendServiceRequest(this.service_id, 'RemoveAgreementRequest', { agreement: agreement });
  }

}

export const dashboardUserSessionService = new DashboardUserSessionServiceInterface();


//////////////////
// WEBPACK FOOTER
// ../ReactorJSCore/dist/services/dashboardusersessionservice.js
// module id = K0ot
// module chunks = 1 2 3